module.exports = __webpack_public_path__ + "img/3-5.d7f305f0.svg";